import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getPaymentTermList(params) {
  return request({
    url: URL.mdm.basicData.paymentTerm,
    method: 'get',
    params
  })
}

export function getPaymentTermsByPlatform(params) {
  return request({
    url: URL.mdm.basicData.platformPaymentTerm,
    method: 'get',
    params
  })
}

export function getAllPaymentTermTemplate(params) {
  return request({
    url: URL.mdm.basicData.paymentTermTemplate,
    method: 'get',
    params
  })
}

export function savePaymentTerm(data) {
  return request({
    url: URL.mdm.basicData.paymentTerm,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function addPaymentTermByPlatform(data) {
  return request({
    url: URL.mdm.basicData.platformPaymentTerm,
    method: 'post',
    data
  })
}

export function savePaymentTerms(data) {
  return request({
    url: URL.mdm.basicData.paymentTerms,
    method: 'post',
    data
  })
}

export function delPaymentTerm(uuid) {
  return request({
    url: URL.mdm.basicData.paymentTerm + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
